/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useMemo } from 'react';

import Loadable from 'react-loadable';

import { cssMap, jsx } from '@atlaskit/css';

import { EmojiPlaceholder } from './emoji-placeholder';

export const LazyEmojiComponentLoader = Loadable({
	loader: async () =>
		(await import(/* webpackChunkName: "@atlaskit-internal_EmojiComponent" */ './emoji-component'))
			.EmojiComponent,
	loading: (props: any) => (props.emoji ? <EmojiPlaceholder {...props} /> : null),
});

const styles = cssMap({
	wrapper: {
		display: 'flex',
		justifyContent: 'center',
	},
});

type EmojiRendererProps = {
	emojiId: string | null;
	height?: number;
	width?: number;
};

export const EmojiRenderer = ({ emojiId, height = 40, width = 40 }: EmojiRendererProps) => {
	const wrapper = useMemo(
		() => (props: any) => (
			<div css={styles.wrapper} style={{ maxWidth: `${width}px` }} {...props} />
		),
		[width],
	);

	if (!emojiId) {
		return null;
	}

	return (
		<LazyEmojiComponentLoader
			emoji={emojiId}
			height={height}
			wrapper={wrapper}
			renderResourcedEmoji
		/>
	);
};
